/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');
    
    var $navigationButtons = $('[data-slider-navigation]');

    $navigationButtons.attr('disabled', false);
    
    if (currentIndex === 0) {
      $navigationButtons
        .filter('[data-slider-navigation-previous]')
        .attr('disabled', true);
    }

    if (currentIndex === $slides.length - 1) {
      $navigationButtons
        .not('[data-slider-navigation-previous]')
        .attr('disabled', true);
      
    }

  }, 7000)

};

sections.extend('slideshow', slideshowAutoExtension);